<template>
  <div class="page_content module_course" aria-label="Create Course Page Content">
    <div class="row page-heading">
      <div class="col-8 input module_heading">
        <span class="module_icon icon-course"></span>
        <b-form-input id="title" type="text"
          v-model.trim="model.title" :state="titleState"
          placeholder="Type in the Course title*"
          aria-label="type in the Course title"
          aria-describedby="titleFeedback" v-focus>
        </b-form-input>
        <span class="icon-master">m</span>
        <b-form-invalid-feedback id="titleFeedback">
          Title must not be empty
        </b-form-invalid-feedback>
      </div>
      <div class="btn-container col-4">
        <template>
          <button class="btn-cancel" @click="cancel">
          <span class="icon-cross"></span>
          </button>
          <button class="btn btn-primary" @click="onSubmit(true)">done</button>
          <button class="btn btn-primary" @click="onSubmit(false)">save</button>
        </template>
      </div>
    </div>
    <div class="row page-content">
      <div class="col-3 thumbnail_panel ace_sec" aria-label="Thumbnail Section">
        <div class="thumbnail_container d-flex ace_sec_txt">
          <div class="icon-photo"></div>
        </div>
        <div class="mb-4 py-3">
          <div class="page_section_row row pl-4 mb-2">
            <label for="folder" id="folderName" ace_sec_txt>Folder</label>
          </div>
          <div class="page_section_row row pl-4 mb-2">
            <select id="folder" v-model="model.owningLibraryId" aria-labelledby="folderName" style="width: 100%;">
              <option v-for="folder in folders" :value="folder.uuid">{{ folder.displayName }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-7 left-spacer ace_sec">
        <div class="page-section">
          <div class="page_section_row description min-content">
            <div class="heading">
              <label for="description" id="courseDescription" class="ace_sec_txt">Course Description</label>
            </div>
            <div class="value" style="padding-right: 5px;">
              <editor
                v-model.trim="model.description"
                :init="({
                  base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                  menubar: false,
                  plugins: plugins,
                  toolbar: toolbar,
                  branding: false,
                  statusbar: false,
                  end_container_on_empty_block: true
                })"
                @onInit="handlerInit"
                id="courseDescriptionId">
                </editor>
            </div>
          </div>
          <div class="page_section_row min-content">
            <div class="heading">
              <label for="coursetype" class="ace_sec_txt">Course Type</label>
            </div>
            <div class="value">
              <div class="row fld_row">
                <div class="col-12 fld_input pr-5">
                  <select id="courseType"  v-model="model.courseType" aria-labelledby="courseType">
                    <option v-for="option in courseTypes" v-bind:value="option">
                      {{ getCourseTypeLabel(option) }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="page_section_row description min-content">
            <div class="heading">
              <label class="ace_sec_txt" for="roomInformation">Course Catalog External ID</label>
            </div>
            <div class="value">
              <input
                type="text"
                class="lms-course-field"
                placeholder="type in the course catalog ID"
                v-model.trim="model.catalogCourseExternalId">
            </div>
          </div>
          <div class="page_section_row clo clo-content" v-if="isMCReady">
            <div class="heading">
              <label for="description" class="ace_sec_txt">Competencies</label>
            </div>
            <div class="value">
              <div class="clo-section">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="clo-container">
                  <template v-for="mc in microcompetencies">
                    <span class="clo-box Course Description" v-b-popover.hover="mc.description" :title="mc.code" v-bind:aria-label="mc.code" @mouseover="competencyPopover" @mouseleave="closeCompetencyPopover">{{mc.code}}</span>
                  </template>
                </div>
              </div>
            </div>
            <div>
              <a href="javascript:void(0)" class="more-link show-more float-right mt-1" @click="expandCollapseClo" style="display:none;" aria-label="more">more</a>
              <a href="javascript:void(0)" class="more-link show-less float-right mt-1" @click="expandCollapseClo" style="display:none;" aria-label="less">less</a>
            </div>
          </div>
          <div class="page_section_row clo clo-content description min-content">
            <div class="heading">
              <label class="ace_sec_txt">Tags</label>
            </div>
            <div class="value" style="float: left; margin-bottom: 35px; width: 97%;">
              <div class="">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="clo-container">
                  <div class="tag-list-section" v-if="isTagsAvailable()">
                    <div class="tag-box-list">
                      <div class="tag-list-length tags_container">
                        <template v-for="(values, key, i) in model.appliedTagMap">
                          <span class="tag ace_sec_txt" v-for="(tag, j) in values">
                          <span class="tag_name instructional_tag">{{tag.name}}</span>
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="no-tags" v-else @click="showAddTagPopup($event)">
                    <div class="tag-box-list">
                      <span class="help-label ace_sec_txt">click to add tags</span>
                    </div>
                  </div>
                  <button type="button" title="edit tag" aria-label="edit tag" class="icon-edit" @click="showAddTagPopup($event)"></button>
                </div>
              </div>
            </div>
            <template>
              <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="create-course-help-modal">
      <b-modal ref="createCourseHelpModal" :title="(sourceId) ? 'Creating a Master from a Section' : 'Creating a New Master'" :header-bg-variant="'course-create-help-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="content-section">
          <span>
          Please use the menu on the left to navigate between various details of
          the course that you are creating. At this time, you can fill in the &#34;About&#34;
          and &#34;Content&#34; details of the course by clicking on the respective tabs. You
          can fill in the name of the course at the top left.
          </span>
        </div>
        <div slot="modal-header" class="header-section">
          <div class="icon"></div>
          <div class="popup-heading" v-if="sourceId">Creating a Master from a Section</div>
          <div class="popup-heading" v-else>Creating a New Master</div>
          <button type="button" class="btn_close" style="float: right;" @click="closeQuickHelpModal" aria-label="close">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="closeQuickHelpModal" class="btn button-primary float-right mr-2" aria-label="ok"> ok </b-button>
        </div>
      </b-modal>
    </div>
    <div class="create-course-competency-tree-modal">
      <b-modal ref="createCourseCompetencyTreeModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="header-section">
          <div class="popup-heading">Competency Tree Found</div>
        </div>
        <div class="page_section_row min-content">
          <div class="heading">
            <label for="coursetype" class="ace_sec_txt">
              {{ $t('selectCourseTypeHd') }}
            </label>
          </div>
          <div class="value">
            <div class="row fld_row">
              <div class="col-12 fld_input pr-5 pl-3">
                <select id="courseVersion"  v-model="version" aria-labelledby="courseVersion">
                  <option v-for="option in courseVersions" v-bind:value="option">
                    {{ getCourseVersionLabel(option) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="heading">
            <label for="coursetype" class="ace_sec_txt">
              {{ $t('selectCompetencyTreeHd') }}
            </label>
          </div>
          <b-form-group>
            <b-form-radio-group stacked v-model="selectedCompetencyId" :options="competencies"></b-form-radio-group>
          </b-form-group>
        </div>
        <div>
          <span>
          Please choose anyone from the above and click continue.
          </span>
        </div>
        <div slot="modal-footer" class="w-100" style="margin-bottom:18px;">
          <b-button @click="createCourseWithCompetencyTree" class="btn continue-btn" :disabled="!selectedCompetencyId" aria-label="continue"> continue </b-button>
          <b-button @click="doNotCreateCourseWithoutCompetencyTree" class="btn button-primary float-right mr-2" aria-label="abort"> abort </b-button>
        </div>
      </b-modal>
    </div>
    <div class="create-course-warning-modal">
      <b-modal ref="createCourseNoCompetencyTreeWarningModal" :title="'No Competency Tree Warning'" :header-bg-variant="'course-create-no-competency-tree-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div>
          <span>
          No competency tree available for the master course <strong>{{title}}</strong>. Are you sure to create without competency tree?
          </span>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="createCourseWithoutCompetencyTree" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
          <b-button @click="doNotCreateCourseWithoutCompetencyTree" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
        </div>
      </b-modal>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
    <div>
      <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DataLossPrompt from '../../common/components/DataLossPrompt'
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'
import CourseNav from './CourseNav'
import AddTagPopup from '../../tagging/components/AddTagPopup'
import Editor from '@tinymce/tinymce-vue'
Vue.directive('focus', {
  inserted (el) {
    el.focus()
  }
})

var EntityData = function (id, title, type, contentFileType, fileType) {
  this.id = id
  this.uuid = undefined
  this.uri = undefined
  this.title = title
  this.type = type
  this.action = undefined
  this.thumbnail = undefined
  this.isDataRendered = false
  this.isStudentEditable = false
  this.children = []
  this.contentFileType = contentFileType
  this.fileType = fileType
  this.html = undefined
  this.originUuid = undefined
}

export default {
  name: 'course-create',
  props: ['sourceId', 'uuid'],
  components: {
    CourseNav,
    AddTagPopup,
    DataLossPrompt,
    Editor
  },
  data: () => {
    return {
      plugins: 'charmap code hr link searchreplace textcolor autoresize media image imagetools table lists',
      toolbar: 'undo redo  bold italic underline bullist numlist outdent indent link unlink alignleft aligncenter alignright alignjustify media insertfile image table forecolor backcolor | searchreplace removeformat | fontselect fontsizeselect styleselect',
      model: {
        title: 'Untitled Course',
        description: undefined,
        owningLibraryId: undefined,
        appliedTagMap: {},
        courseType: 'SUGGESTION_PLUS_BASED',
        version : 'V1'
      },
      plan: [],
      folders: [],
      courseTypes: ['SUGGESTION_PLUS_BASED', 'BASIC'],
      courseVersions: ['V1', 'V2'],
      entityType: {
        TOPIC: 'LearningTopic',
        ASSET: 'LearningContent'
      },
      courseId: '',
      competencies: [],
      selectedCompetencyId: undefined,
      version: 'V1',
      isDone: false,
      isMCReady: false,
      taggingEntityData: {},
      isShowTagPopup: false,
      isNuNavLogin: (window.location.host.indexOf('nunav') !== -1 || window.location.host.indexOf('competencyedu') !== -1 || window.location.host.indexOf('wsp') !== -1),
      nextPage: undefined,
      dirty: false,
      oldModel: {}
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.populateLibrary()
      if (this.uuid) {
        this.loadCourse()
      } else {
        if (this.sourceId) {
          this.loadCopyCourseDetail(this.sourceId).then(res => {
            if (res) {
              this.model.title = res.title
              this.model.masterCourseId = res.masterCourseId
              this.model.description = res.description
              this.model.version = res.version
              this.model.owningLibraryId = res.owningLibraryId
              this.model.catalogCourseExternalId = res.catalogCourseExternalId
              if (res.appliedTagMap) {
                this.model.appliedTagMap = res.appliedTagMap
              }
              if (res.plan && res.plan.length > 0) {
                this.renderPlan(JSON.parse(res.plan), this.plan, 'COPY')
              }
            }
            this.$data.oldModel = _.cloneDeep(this.$data.model)
          })
        } else {
          this.$data.oldModel = _.cloneDeep(this.$data.model)
        }
        $('#about').children().addClass('active')
        // Uncomment when required to show quick help message
        // this.$refs.createCourseHelpModal.show()
        // Comment out when above line is uncommented
        $('#title').select()
      }
    })
  },

  beforeRouteLeave (to, from, next) {
    if (this.dirty) {
      this.nextPage = next
      this.$refs.dataLossAlert.showPrompt()
      next(false)
    } else {
      next()
    }
  },

  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'microcompetencies': state => state.course.microcompetencies
    }),

    titleState () {
      return this.model.title.length > 0
    }
  },

  updated () {
    // this.showEllipsisTags()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.showEllipsisTags()
      })
    })
  },

  methods: {
    ...mapActions([
      'loadLibrariesForUser',
      'loadCopyCourseDetail',
      'saveCourseDetail',
      'loadCourseDetail',
      'loadMicroCompetencies',
      'loadCourseTopics',
      'deleteCourseDetail',
      'loadPLOForInstitution',
      'addCompetencyTreeToCourse',
      'loadPermission'
    ]),

    handlerInit (ev, editor) {
      $('#courseDescriptionId_ifr').css({width: '100%', height: '250px', border: '1px solid #ccc'})
    },

    closeQuickHelpModal () {
      this.$refs.createCourseHelpModal.hide()
      $('#title').select()
    },
    getCourseVersionLabel (version) {
      if (version === 'V1') {
        return 'Traditional Course with fixed Competency Tree'
      } else if (version === 'V2') {
        return 'Modular Course with flexibled Competency Tree'
      } else {
        return 'Version 1'
      }
    },
    getCourseTypeLabel (courseType) {
      if (courseType === 'SUGGESTION_SUPPLEMENT_BASED' || courseType === 'SUGGESTION_PLUS_BASED' || courseType === 'SUGGESTION_BASED') {
        return 'Problem Based Learning'
      } else if (courseType === 'BASIC') {
        return 'Competency Based Learning'
      } else {
        return 'Topic Based Learning'
      }
    },

    populateLibrary () {
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
            if (!this.model.owningLibraryId && learningSpace.category === 'Institute_Public') {
              this.model.owningLibraryId = learningSpace.uuid
            }
          }
        }
        this.$data.oldModel = _.cloneDeep(this.$data.model)
      })
    },

    showEllipsisTags () {
      var tagListLength = $('.tag-list-length').height()
      if (tagListLength > 34) {
        $('.ellipsisTags').show()
      } else {
        $('.ellipsisTags').hide()
      }
    },

    isTagsAvailable () {
      let values = Object.values(this.model.appliedTagMap)
      return values.find((value) => {
        return value.length > 0
      })
    },

    showAddTagPopup (event) {
      this.isShowTagPopup = true
      this.taggingEntityData = {title: this.model.title, type: 'course', appliedTagMap: this.model.appliedTagMap}
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
      }, 500)
    },

    cancel () {
      this.returnToDashboard()
    },

    createNewEntity (item) {
      if (item) {
        var type = this.entityType.TOPIC
        if (item.resourceType === 'learningcontent' || item.objectType === 'LearningContent' || item.resourceType === 'lmscontent' || item.objectType === 'lmscontent' || item.type === 'LearningContent') {
          type = this.entityType.ASSET
        }
        var id = this.entityId++
        var entity = new EntityData(id, item.title, type, item.contentFileType, item.fileType)
        if (item.uuid) {
          entity.uuid = item.uuid
        }
        if (item.externalId) {
          entity.externalId = item.externalId
        }
        if (item.importedExportedSynced) {
          entity.importedExportedSynced = item.importedExportedSynced
        }
        if (item.uri) {
          entity.uri = item.uri
        }
        if (item.thumbnail) {
          entity.thumbnail = item.thumbnail
        }
        if (item.embedlyHtml) {
          entity.html = item.embedlyHtml
        }
        if (item.description) {
          entity.description = item.description
        }
        if (item.originUuid) {
          entity.originUuid = item.originUuid
        }
        if (item.ancestor) {
          entity.ancestor = item.ancestor
        }
        if (item.owningLibraryId) {
          entity.owningLibraryId = item.owningLibraryId
        }
        if (item.studentEditable) {
          entity.isStudentEditable = item.studentEditable
        }
        entity.customType = item.type
        if (item.fileSize) {
          entity.fileSize = item.fileSize
        }
        if (item.appliedTagMap) {
          var appliedTagMap = item.appliedTagMap
          entity.appliedTagMap = appliedTagMap
        }
        if (item.maxAttempt) {
          entity.maxAttempt = item.maxAttempt
        }
        if (item.localPractice) {
          entity.localPractice = item.localPractice
        }
        if (item.creationTime) {
          entity.creationTime = item.creationTime
        }
        return entity
      }
    },

    renderPlan (plan, data, action) {
      if (plan) {
        $.each(plan, (index, item) => {
          var newEntity = this.createNewEntity(item)
          if (action) {
            newEntity.action = action
          }
          if (newEntity.type === this.entityType.TOPIC) {
            newEntity.isDataRendered = true
          }
          data.push(newEntity)
          if ((item.objectType === this.entityType.TOPIC) && item.plan) {
            this.renderPlan(JSON.parse(item.plan), newEntity.children, action)
          }
        })
      }
    },

    generatePlan (plan) {
      $.each(plan, (i, item) => {
        delete item.id
        if (item.type === 'LearningTopic') {
          if (item.children.length > 0) {
            this.generatePlan(item.children)
          }
        } else {
          delete item.children
          delete item.isDataRendered
          delete item.isStudentEditable
        }
      })
      return JSON.stringify(plan)
    },

    onSubmit (isDone) {
      if (this.titleState) {
        this.dirty = false
        this.isDone = isDone
        this.$refs.loadingModal.show()
        var data = {
          master: true,
          title: this.model.title,
          masterCourseId: this.model.masterCourseId,
          description: this.model.description,
          appliedTagMap: this.model.appliedTagMap,
          courseType: this.model.courseType,
          version:this.version,
          plan: this.generatePlan(this.plan),
          owningLibraryId: this.model.owningLibraryId,
          catalogCourseExternalId: this.model.catalogCourseExternalId
        }
        if (this.uuid) {
          data.uuid = this.uuid
        }
        this.saveCourseDetail(data).then((res) => {
          this.courseId = res.uuid
          if (this.uuid) {
            this.showMessageAndRedirect(' updated successfully.')
          } else {
            const plan = JSON.parse(res.plan)
            if (plan.length > 0) {
              this.plan = []
              this.renderPlan(plan, this.plan)
              this.showMessageAndRedirect(' created successfully.')
            } else {
              this.loadPLOForInstitution().then((data) => {
                this.$refs.loadingModal.hide()
                if (data) {
                  let items = _.orderBy(data, ['lastUpdatedTime'], ['desc'])
//                  this.competencies.push({text: 'Competency Tree-Empty', value: 'NONE'})
                  $.each(items, (index, competency) => {
                    this.competencies.push({text: competency.displayTitleForTeacher, value: competency.uuid})
                  })
                  this.$refs.createCourseCompetencyTreeModal.show()
                } else {
                  this.$refs.createCourseNoCompetencyTreeWarningModal.show()
                }
              })
            }
          }
        })
      }
    },

    showMessageAndRedirect (message) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: 'Master Course "' + this.model.title + '"' + message
      })
      if (this.isDone) {
        if (this.nextPage) {
          this.$emit('resolveNext', this.nextPage)
        } else {
          setTimeout(() => {
            this.returnToDashboard()
          }, 1000)
        }
      } else {
        this.$refs.loadingModal.hide()
        return this.$router.push({ name: 'courseEdit', params: { uuid: this.courseId } })
      }
    },

    returnToDashboard () {
      let userPermission = this.permission.userPermission
      if (userPermission.studentHomeView) {
        return this.$router.push({ name: 'studentDashboard' })
      } else if (userPermission.employerAdminHomeView) {
        return this.$router.push({ name: 'employerAdmin' })
      } else if (userPermission.advisorHomeView) {
        return this.$router.push({ name: 'advisorDashboard' })
      } else if (userPermission.instructorHomeView) {
        if (userPermission.adminHomeView) {
          let name = (this.isNuNavLogin) ? 'nunavAdminDashboard' : 'adminDashboard'
          return this.$router.push({ name: name })
        } else {
          return this.$router.push({ name: 'instructorDashboard' })
        }
      }
    },

    createCourseWithCompetencyTree () {
      this.$refs.createCourseCompetencyTreeModal.hide()
      this.$refs.loadingModal.show()
      this.addCompetencyTreeToCourse({courseId: this.courseId, competencyId: this.selectedCompetencyId, version:this.version}).then(res => {
        setTimeout(() => {
          this.showMessageAndRedirect(' created successfully.')
        }, 1000)
      })
    },

    createCourseWithoutCompetencyTree () {
      this.$refs.createCourseNoCompetencyTreeWarningModal.hide()
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.showMessageAndRedirect(' created successfully.')
      }, 1000)
    },

    doNotCreateCourseWithoutCompetencyTree () {
      this.$refs.createCourseNoCompetencyTreeWarningModal.hide()
      this.$refs.loadingModal.show()
      this.deleteCourseDetail(this.courseId).then(res => {
        setTimeout(() => {
          this.returnToDashboard()
        }, 1000)
      })
    },

    loadCourse () {
      this.loadCourseDetail(this.uuid).then(res => {
        if (res) {
          $('#about').children().addClass('active')
          this.model.title = res.title
          this.model.masterCourseId = res.masterCourseId
          this.model.description = res.description
          this.model.owningLibraryId = res.owningLibraryId
          this.model.catalogCourseExternalId = res.catalogCourseExternalId
          if (res.appliedTagMap) {
            this.model.appliedTagMap = res.appliedTagMap
          }
          if (res.competencies[0]) {
            this.loadMicroCompetencies(res.competencies[0]).then(respons => {
              this.isMCReady = true
            })
          }
        }
        this.$data.oldModel = _.cloneDeep(this.$data.model)
      })
      this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true})
    },

    competencyPopover () {
      $('.clo-box').mouseover(function () {
        $('body').addClass('competency-popover')
      })
    },

    closeCompetencyPopover () {
      $('.clo-box').mouseleave(function () {
        $('body').removeClass('competency-popover')
      })
    },

    expandCollapseClo () {
      if ($('.clo').hasClass('clo-content')) {
        $('.clo').toggleClass('expandClo', 500)
      }
    },

    okLose () {
      this.$emit('resolveNext', this.nextPage)
    },

    saveAndContinue () {
      this.onSubmit(true)
    }
  },

  watch: {
    model: {
      handler () {
        this.dirty = !_.isEqual(this.$data.model, this.$data.oldModel)
      },
      deep: true
    }
  }
}
</script>

<style>

    a.disabled {
        color: #dcdad1 !important;
        pointer-events: none;
    }

    .header-section {
        width: 100%;
    }


</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseCreate.vue